import { Warning } from '@mui/icons-material';
import { Badge, Box } from '@mui/material';

export const FSPWarningIndicator = ({ count }: { count: number }) => {
  return (
    <Box color="var(--alert)">
      <Badge badgeContent={count} color="default">
        <Warning color="warning" />
      </Badge>
    </Box>
  );
};
